module.exports = __webpack_public_path__ + "img/logo-bigpicture-text.e0c7d25c.svg";